/*
 *
 * Users actions
 *
 */

import {
  CLEAR_FILTER,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  DELETE_USER,
  DELETE_USER_ERROR,
  DELETE_USER_SUCCESS,
  FILTER_USERS,
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_ERROR,
  INVITE_USER,
  INVITE_USER_ERROR,
  INVITE_USER_SUCCESS,
  TOGGLE_SHOW_CREATE_USER_FORM,
  GET_ALL_USERS,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_ERROR,
  DELETE_AAD_USER,
  DELETE_AAD_USER_SUCCESS,
  DELETE_AAD_USER_ERROR,
  UNLINK_AAD_USER,
  UNLINK_AAD_USER_ERROR,
  UNLINK_AAD_USER_SUCCESS,
  CLOSE_DEFAULT_ROLES_MODAL,
  SET_CREATED_USER,
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_ERROR,
  SET_SELECTED_USER,
  GET_USERS_BY_COMPANY,
  GET_USERS_BY_COMPANY_SUCCESS,
  GET_USERS_BY_COMPANY_ERROR,
} from './constants'

export const createUser = (user, customerCode, companyCode, role) => ({
  type: CREATE_USER,
  user,
  customerCode,
  companyCode,
  role,
})

export const createUserSuccess = (user) => ({
  type: CREATE_USER_SUCCESS,
  user,
})

export const closeDefaultRolesModal = () => ({
  type: CLOSE_DEFAULT_ROLES_MODAL,
})

export const createUserError = (error) => ({
  type: CREATE_USER_ERROR,
  error,
})

export const getUsers = (customerCode, companyCode, role) => ({
  type: GET_USERS,
  customerCode,
  companyCode,
  role,
})

export const getUsersSuccess = (users) => ({
  type: GET_USERS_SUCCESS,
  users,
})

export const getUsersError = (error) => ({
  type: GET_USERS_ERROR,
  error,
})

export const getAllUsers = () => ({
  type: GET_ALL_USERS,
})

export const getAllUsersSuccess = (users) => ({
  type: GET_ALL_USERS_SUCCESS,
  users,
})

export const getAllUsersError = (error) => ({
  type: GET_ALL_USERS_ERROR,
  error,
})

export const getUsersByCompany = (companyCode) => ({
  type: GET_USERS_BY_COMPANY,
  companyCode,
})

export const getUsersByCompanySuccess = ({ users, companyCode }) => ({
  type: GET_USERS_BY_COMPANY_SUCCESS,
  users,
  companyCode,
})

export const getUsersByCompanyError = ({ error, companyCode }) => ({
  type: GET_USERS_BY_COMPANY_ERROR,
  error,
  companyCode,
})

export const deleteAADUser = (userId) => ({
  type: DELETE_AAD_USER,
  userId,
})

export const deleteAADUserSuccess = (userId) => ({
  type: DELETE_AAD_USER_SUCCESS,
  userId,
})

export const deleteAADUserError = (error) => ({
  type: DELETE_AAD_USER_ERROR,
  error,
})
export const inviteUser = (
  user,
  email,
  resend = false,
  view = 'users',
  signOut = false
) => ({
  type: INVITE_USER,
  user,
  email,
  resend,
  view,
  signOut,
})
export const inviteUserSuccess = (users, view) => ({
  type: INVITE_USER_SUCCESS,
  users,
  view,
})
export const inviteUserError = (error) => ({
  type: INVITE_USER_ERROR,
  error,
})
export const unlinkAADUser = (userId, allUsersView) => ({
  type: UNLINK_AAD_USER,
  userId,
  allUsersView,
})

export const unlinkAADUserSuccess = (userId, allUsersView) => ({
  type: UNLINK_AAD_USER_SUCCESS,
  userId,
  allUsersView,
})

export const unlinkAADUserError = (error) => ({
  type: UNLINK_AAD_USER_ERROR,
  error,
})

export const deleteUser = (userId, customerCode, companyCode, role) => ({
  type: DELETE_USER,
  userId,
  customerCode,
  companyCode,
  role,
})

export const deleteUserSuccess = (userId) => ({
  type: DELETE_USER_SUCCESS,
  userId,
})

export const deleteUserError = (error) => ({
  type: DELETE_USER_ERROR,
  error,
})

export const toggleShowCreateUserForm = () => ({
  type: TOGGLE_SHOW_CREATE_USER_FORM,
})

export const filterUsers = (filteredUsers) => ({
  type: FILTER_USERS,
  filteredUsers,
})

export const clearFilter = () => ({
  type: CLEAR_FILTER,
})

export const setCreatedUser = (user) => ({
  type: SET_CREATED_USER,
  user,
})

export function getUser(userId) {
  return {
    type: GET_USER,
    userId,
  }
}

export function getUserSuccess(user) {
  return {
    type: GET_USER_SUCCESS,
    user,
  }
}

export function getUserError(error) {
  return {
    type: GET_USER_ERROR,
    error,
  }
}

export const setSelectedUser = (user) => ({
  type: SET_SELECTED_USER,
  user,
})
